import React from "react";
import { Chip } from "./Chip";

export const RangeChip = React.forwardRef((props, ref) => {
    let {filterValue, title, trans, type } = props,
          {icon = "numeric", iconFamily="material-community" } = props,
          {min, max, } = filterValue?.value || {};

    let value = ""
    if (min && max) {
        value = trans(`filters.range.${type}.between`, { min, max });
    } else if (min) {
        value = trans(`filters.range.${type}.greater_than`, { min, max, value: min });
    } else if (max) {
        value = trans(`filters.range.${type}.less_than`, { min, max, value: max });
    }

    title = value ? `${title}: ${value}` : title ;

    const chipProps = {
        ...props,
        icon, iconFamily,
        tooltip: value ? title : "",
        title,
    }
    return <Chip ref={ref} { ...chipProps } />
})